import { LoadingContainer } from '../styled-components'
import { SpinnerGrey } from '../../../atoms/icons/special'
import { iconSizeOptions } from '../../../atoms/icons/icons-sizes'

const TopBarLoadingContent = () => {
  return (
    <LoadingContainer>
      <SpinnerGrey size={iconSizeOptions['ICON-XL']} />
    </LoadingContainer>
  )
}

export default TopBarLoadingContent
